import React from 'react'
import {connect} from 'react-redux'
import {Flex, Arrow} from '/app/src/component'

import MessagesList from '/app/src/component/Conversation/MessagesList'
import {CustomerPreviousTickets} from '/app/src/container'
import ConversationModel from '/app/src/model/Conversation/model'
import ConversationSelector from '/app/src/model/Conversation/selector'

class AssignedPrevious extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            'view': null,
        }

        this._renderListView = this._renderListView.bind(this);
        this._renderSingleView = this._renderSingleView.bind(this);

        this._toSingleView= this._toSingleView.bind(this);
        this._toListView= this._toListView.bind(this);
    }

    _toSingleView(room){
        let conversation = this.props.conversations.get(room)
        if(!ConversationSelector.getConfirmedEntries(conversation).size){
            this.props.dispatch(ConversationModel.readEntries(room))
        }
        this.setState({
            'view': room
        })
    }
    _toListView(){
        this.setState({
            'view': ''
        })
    }

    _renderListView(){
        const customer = this.props.customer;
        return <CustomerPreviousTickets customer={customer} toSingleView={this._toSingleView}/>
    }

    _renderSingleView(){
        return (
            <Flex column>
                <Flex w='100%' backgroundColor='mediumgrey' basis='35px' shrink={0} vAlignContent='center' paddingLeft='10px'
                    fontWeight='500' color='black' onClick={this._toListView} cursor='pointer'
                    backgroundHover='lightblue'
                >
                    <Arrow direction='left' color='inherit' size='xsmall'/>
                    <Flex paddingLeft='3px'>Tillbaka</Flex>
                </Flex>

                <Flex w='100%' paddingLeft='15px'>
                <MessagesList room={this.state.view} toListView={this._toListView}/>
                </Flex>
            </Flex>
            );
    }

    render(){
        return this.state.view ? this._renderSingleView() : this._renderListView()
    }
}

function mapStateToProps(state){
    const conversations = ConversationSelector.getItems(state)
    return {
        conversations: conversations
    }

}

export default connect(mapStateToProps)(AssignedPrevious)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/Conversation/Assigned/Previous.js